export class DbmCluESignRunProcessParams {
    ESIGN_TOKEN : string;
    ESIGN_CODE : string;
    ESIGN_SF_GENRE : number;
    ESIGN_SF_PRENOM : string;
    ESIGN_SF_NOM : string;
    ESIGN_SF_MESSAGE : string;
    ESIGN_SF_SIGNATUREDATA : string;
}